import { render, staticRenderFns } from "./versionUpload.vue?vue&type=template&id=dc9105b0&scoped=true"
import script from "./versionUpload.vue?vue&type=script&lang=js"
export * from "./versionUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc9105b0",
  null
  
)

export default component.exports